var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4478 16.3563C13.987 17.6194 12.0827 18.3835 9.99996 18.3835C5.39758 18.3835 1.66663 14.6525 1.66663 10.0501C1.66663 5.44776 5.39758 1.7168 9.99996 1.7168C14.6023 1.7168 18.3333 5.44776 18.3333 10.0501C18.3333 11.8302 17.7751 13.48 16.8243 14.834L14.1666 10.0501H16.6666C16.6666 6.36823 13.6819 3.38346 9.99996 3.38346C6.31806 3.38346 3.33329 6.36823 3.33329 10.0501C3.33329 13.732 6.31806 16.7168 9.99996 16.7168C11.7918 16.7168 13.4185 16.0099 14.6165 14.8598L15.4478 16.3563Z",
    fill: "#2262ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh_icon.1ccabbb7d1a85606025ef780ef2591d0.svg";
export { ForwardRef as ReactComponent };